import { create } from 'zustand';
import { ICreator } from '~/types';

export interface Props {
  isModalOpen: boolean;
  creatorId: string | undefined;
  webLinks: string[];
  selectedWebLinkIndex: number | undefined;
  setSelectedWebLinkIndex: (webLinkIndex?: number | undefined) => void;
  setIsModalOpen: (open: boolean) => void;
  showWebLinks: (creator: ICreator) => void;
  setWebLinks: (webLinks: string[]) => void;
  reset: () => void;
}

export const useWebLinksStore = create<Props>((set) => ({
  isModalOpen: false,
  creatorId: undefined,
  webLinks: [],
  selectedWebLinkIndex: undefined,
  setIsModalOpen: (open) => set(() => ({ isModalOpen: open })),
  setSelectedWebLinkIndex: (webLinkIndex) =>
    set(() => ({ selectedWebLinkIndex: webLinkIndex })),
  showWebLinks: (creator) => {
    return set(() => {
      return {
        creatorId: creator?.id,
        webLinks: creator?.webLinks ? creator.webLinks : [],
        isModalOpen: true,
      };
    });
  },
  setWebLinks: (webLinks) => set(() => ({ webLinks })),
  reset: () =>
    set(() => ({
      isModalOpen: false,
      creatorId: undefined,
      webLinks: [],
      selectedWebLinkIndex: undefined,
    })),
}));
